import axios from 'axios';
import { variables } from './variables.js';
import axiosInstance from './axiosInstance';

const API_URL = variables.STOCKITEM_API

const getGroupItems = async (params) => {
  const queryString = params ? `${params}` : '';
  const response = await axiosInstance.get(`${API_URL}/${queryString}`);
  return response.data;
}

export default { 
  getGroupItems 
};